import { BadgeWithIconProps } from "../data-model/badgeWithIconProps";

export enum MedicalPaOrderStatus {
  NEW = "new",
  PENDING = "pending",
  COMPLETED = "completed",
  DENIED = "denied",
  APPROVED = "approved",
  REVIEWED = "reviewed",
  REJECTED = "rejected",
  FINANCIAL = "financial",
  AUTHORIZED = "authorized",
  NOT_AVAILABLE = "not_available",
  PAYER_NOT_SUPPORTED = "payer_not_supported",
  HOLD = "hold",
  QUERY = "query",
  PHARM_FILL = "pharm_fill",
  ALREADY_FILLED = "already_filed",
  ERROR = "error",
  IN_PROGRESS = "in_progress",
}

// export const authStatusOptions: BadgeWithIconProps[] = [
//   {
//     id: MedicalPaOrderStatus.QUERY,
//     text: "Query",
//     bgColor: "#F6E5FF",
//     textColor: "#4B00CC",
//     priority: 1,
//   },
//   {
//     id: MedicalPaOrderStatus.HOLD,
//     text: "Hold",
//     bgColor: "#FFF3E0",
//     textColor: "#C24400",
//     priority: 2,
//   },
//   {
//     id: MedicalPaOrderStatus.AUTH_REQUIRED,
//     text: "Auth Required",
//     bgColor: "#FFF3E0",
//     textColor: "#C24400",
//     priority: 3,
//   },
//   {
//     id: MedicalPaOrderStatus.PENDING,
//     text: "Pending",
//     bgColor: "#FFFCD6",
//     textColor: "#665D00",
//     priority: 4,
//   },
//   {
//     id: MedicalPaOrderStatus.DENIED,
//     text: "Denied",
//     bgColor: "#FFE8E8",
//     textColor: "#CC0300",
//     priority: 5,
//   },
//   {
//     id: MedicalPaOrderStatus.NAR,
//     text: "NAR",
//     bgColor: "#EBFFFF",
//     textColor: "#007A7A",
//     priority: 7,
//   },
//   {
//     id: MedicalPaOrderStatus.AUTH_ON_FILE,
//     text: "Auth On File",
//     bgColor: "#F8FFEB",
//     textColor: "#537A00",
//     priority: 8,
//   },
//   {
//     id: MedicalPaOrderStatus.POD,
//     text: "POD",
//     bgColor: "#FFEBFB",
//     textColor: "#C20097",
//     priority: 9,
//   },
//   {
//     id: MedicalPaOrderStatus.NOT_TO_WORK_FEDORA,
//     text: "Not to Work/Fedora",
//     bgColor: "#F5F5F5",
//     textColor: "#0F0F0F",
//     priority: 10,
//   },
//   {
//     id: MedicalPaOrderStatus.NOT_TO_WORK_STAT_CASE,
//     text: "Not to Work/Stat Case",
//     bgColor: "#F5F5F5",
//     textColor: "#0F0F0F",
//     priority: 11,
//   },
//   {
//     id: MedicalPaOrderStatus.NOT_TO_WORK,
//     text: "Not to Work",
//     bgColor: "#F5F5F5",
//     textColor: "#0F0F0F",
//     priority: 12,
//   },
//   {
//     id: MedicalPaOrderStatus.ORAL_DRUG,
//     text: "Oral Drug",
//     bgColor: "#F5F5F5",
//     textColor: "#0F0F0F",
//     priority: 13,
//   },
//   {
//     id: MedicalPaOrderStatus.NEW,
//     text: "New",
//     bgColor: "#EAF2FF",
//     textColor: "#0056D6",
//   },

//   {
//     id: MedicalPaOrderStatus.NOT_AVAILABLE,
//     text: "Not Available",
//     bgColor: "#F5F5F5",
//     textColor: "#0F0F0F",
//     priority: 14,
//   },
//   {
//     id: MedicalPaOrderStatus.NO_AUTH_REQUIRED,
//     text: "No Auth Required",
//     bgColor: "#EAF2FF",
//     textColor: "#0056D6",
//     priority: 15,
//   },
//   {
//     id: MedicalPaOrderStatus.PATIENT_OWNED_DRUG,
//     text: "Patient Owned Drug",
//     bgColor: "#FFF3E0",
//     textColor: "#C24400",
//     priority: 16,
//   },
//   {
//     id: MedicalPaOrderStatus.REQUIRED,
//     text: "Required",
//     bgColor: "#FFF3E0",
//     textColor: "#C24400",
//   },
// ];

export const financialStatusOptions: BadgeWithIconProps[] = [
  {
    id: MedicalPaOrderStatus.NEW,
    text: "New",
    bgColor: "#EAF2FF",
    textColor: "#0056D6",
  },
  {
    id: MedicalPaOrderStatus.FINANCIAL,
    text: "Financial",
    bgColor: "#FFFCD6",
    textColor: "#665D00",
  },
  {
    id: MedicalPaOrderStatus.AUTHORIZED,
    text: "Authorized",
    bgColor: "#E6F3F0",
    textColor: "#005D49",
    priority: 6,
  },
  {
    id: MedicalPaOrderStatus.HOLD,
    text: "Hold",
    bgColor: "#FFF3E0",
    textColor: "#C24400",
    priority: 2,
  },
  {
    id: MedicalPaOrderStatus.QUERY,
    text: "Query",
    bgColor: "#EEE6FBFF",
    textColor: "#A030A0",
  },
  {
    id: MedicalPaOrderStatus.PHARM_FILL,
    text: "Pharm Fill",
    bgColor: "#F5F5F5",
    textColor: "#0F0F0F",
  },
];
